<template>
  <notification
    type="is-danger"
    icon="fa-exclamation-circle"
    @delete="$emit('delete')"
  >
    Urządzenie zostało zablokowane w związku z przekroczonym limitem prób
    logowania podjętych przy użyciu nieprawidłowego tokenu.
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "failed-token-exchange-limit-exceeded-notification",

  components: {
    Notification
  }
};
</script>

<style></style>
